module.exports = __webpack_public_path__ + "static/media/credit-card-icon-w.1a3b4d0f.svg";